export const fbConfig = {
	apiKey: "AIzaSyDqoiOpn7F0vG1GNLcQdWZjw_RxvITfMhY",
	authDomain: "tj-moore.firebaseapp.com",
	projectId: "tj-moore",
	storageBucket: "tj-moore.firebasestorage.app",
	messagingSenderId: "315916534327",
	appId: "1:315916534327:web:1060fb914c87e1d49ab5b2",
	measurementId: "G-Y4J3VH28N9"
};
